import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { OperationalRoleAccessService } from '../core/operational-role-access.service';
import {
  canAuthorWoundEvaluation,
  isWoundReportOnly,
} from '../core/wound-access';

type WoundAccessDecision = 'author' | 'report_only' | 'denied';

@Injectable({ providedIn: 'root' })
export class WoundEvaluationGuard implements CanActivate {
  constructor(
    private readonly access: OperationalRoleAccessService,
    private readonly router: Router
  ) {}

  canActivate(): Observable<boolean | UrlTree> {
    return this.access.roles$().pipe(
      map((roles) => {
        const decision = this.decision(roles);
        if (decision === 'author') return true;
        if (decision === 'report_only') {
          return this.router.createUrlTree(['/wound-rounds/dashboard'], {
            queryParams: { reason: 'wound-reports-only' },
          });
        }
        return this.router.createUrlTree(['/forbidden']);
      })
    );
  }

  private decision(roles: string[]): WoundAccessDecision {
    if (canAuthorWoundEvaluation(roles)) return 'author';
    if (isWoundReportOnly(roles)) return 'report_only';
    return 'denied';
  }
}
